export default __webpack_public_path__ + "static/media/gad-score.42a26b08.png";